import React, { Suspense, lazy, useState } from 'react';
import { Card, Tabs, LoadingSpinner } from 'components/common';
import { useSelector } from 'react-redux';
import { MdListAlt } from 'react-icons/md';
import PositionGroupHeader from './position_group/PositionGroupHeader';

const AllList = lazy(() => import('./position_group/PostitionGroupList'));

const PositionGroups = () => {
  const { loading } = useSelector((state) => state.organization_position_group);
  const [selected, setSelected] = useState([]);

  return (
    <>
      <PositionGroupHeader selected={selected} />

      {loading &&
        <div className="tw-text-center tw-my-2">
          <LoadingSpinner />
        </div>
      }

      <Card padding="none">
        <Tabs
          variant="underline"
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'All',
              icon: <MdListAlt size={14} />,
              content: (
                <Suspense fallback={
                  <div className="tw-text-center tw-my-2">
                    <LoadingSpinner />
                  </div>
                }>
                  <AllList setSelected={setSelected} />
                </Suspense>
              ),
            },
          ]}
        />
      </Card>
    </>
  );
};

export default PositionGroups;
